<template>
	<div class="ArrowRight svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1703839100378" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10897" :width="size" :height="size">
			<path d="M873.1 596.2l-164-208C703 380.5 693.8 376 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" fill="#1e90ff" p-id="10898"></path>
		</svg>
	</div>
</template>
<script setup name="ArrowRight">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 24
		}
	})
</script>
<style scoped lang="less">
	.ArrowRight,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
